import { render, staticRenderFns } from "./CommentInputBox.vue?vue&type=template&id=f1fabdc2&scoped=true&"
import script from "./CommentInputBox.vue?vue&type=script&lang=js&"
export * from "./CommentInputBox.vue?vue&type=script&lang=js&"
import style0 from "./CommentInputBox.vue?vue&type=style&index=0&id=f1fabdc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fabdc2",
  null
  
)

export default component.exports